import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';
import { useMembershipApi } from './apiHooks';
import { CENTURION } from '../constants/commonConstants';

export const useTopCard = () => {
  const { data } = useMembershipApi();
  return !data || !data?.membership ? undefined
    : data.membership?.filter((account) => account.demographics.isTopCard)[0];
};

export const useIsCenturion = () => {
  const topCard = useTopCard();
  return !topCard ? false : topCard?.demographics.product.productFamily === CENTURION;
};

export const useGetMRPointsBalance = () => {
  const topCard = useTopCard();
  const activeLocale: string = useSelector(getActiveLocaleSelector);
  return !topCard ? '' : topCard?.loyalty?.pointsBalance.toLocaleString(activeLocale);
};
